import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartsRoutingModule } from '@app/charts/charts-routing.module';
import { ChartsListComponent } from '@app/charts/charts-list/charts-list.component';
import { ChartsComponent } from '@app/charts/charts/charts.component';
import { ChartsFilterComponent } from "@app/charts/charts-filter/charts-filter.component";

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartsKpiComponent } from '@app/charts/charts-kpi/charts-kpi.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@app/shared/shared.module';
import { AirlineGuard } from '@app/core/guards/airline.guard';

@NgModule({
  imports: [
    CommonModule,
    ChartsRoutingModule,
    NgxChartsModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule
  ],
  declarations: [
    ChartsListComponent,
    ChartsKpiComponent,
    ChartsComponent,
    ChartsFilterComponent
  ],
  providers: [ AirlineGuard ]
})
export class ChartsModule { }
